import React, { useEffect, useContext } from 'react';
import { GlobalContext } from '../contexts/GlobalContext';
import RefSetSearchBar from './RefSetSearchBar';
import RefSetBody from './RefSetBody';

import './PageRefSets.css';

function PageRefSets() {

	const globals = useContext(GlobalContext)

	useEffect(() => {
		globals.initAnalytics();
		globals.logPageAnalytics();
	}, [globals])

	return (
		<div className="pageRefSets">
			<RefSetSearchBar />
			<RefSetBody />
		</div>
	);
};

export default PageRefSets;
